"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BASE_COLORS = exports.DEFAULT_WOBBLE = exports.DEFAULT_SHAPE_COUNT = void 0;
var color_1 = __importDefault(require("color"));
var mersenne_twister_1 = __importDefault(require("mersenne-twister"));
exports.DEFAULT_SHAPE_COUNT = 3;
exports.DEFAULT_WOBBLE = 30;
exports.DEFAULT_BASE_COLORS = [
    '#01888C',
    '#FC7500',
    '#034F5D',
    '#F73F01',
    '#FC1960',
    '#C7144C',
    '#F3C100',
    '#1598F2',
    '#2465E1',
    '#F19E02',
];
function Jazzicon(address, shapeCount, wobble, baseColors) {
    if (shapeCount === void 0) { shapeCount = exports.DEFAULT_SHAPE_COUNT; }
    if (wobble === void 0) { wobble = exports.DEFAULT_WOBBLE; }
    if (baseColors === void 0) { baseColors = exports.DEFAULT_BASE_COLORS; }
    if (!/^0x[0-9a-fA-F]{40}$/.test(address))
        throw new Error('Invalid address');
    if (shapeCount + 1 > baseColors.length)
        throw new Error('Insufficient base colors');
    var seed = parseInt(address.slice(2, 10), 16);
    var generator = new mersenne_twister_1.default(seed);
    var position = generator.random();
    var hueShift = 30 * position - wobble / 2;
    var colors = baseColors.map(function (hex) { return (0, color_1.default)(hex).rotate(hueShift).hex(); });
    function nextColor() {
        var unused = generator.random();
        var position = generator.random();
        var index = Math.floor(colors.length * position);
        var color = colors.splice(index, 1)[0];
        return color || '#FFFFFF';
    }
    function nextTransform(index) {
        var firstRotation = generator.random();
        var boost = generator.random();
        var secondRotation = generator.random();
        var angle = 2 * Math.PI * firstRotation;
        var velocity = 100 * (index + boost) / shapeCount;
        var x = Math.cos(angle) * velocity;
        var y = Math.sin(angle) * velocity;
        var r = firstRotation * 360 + secondRotation * 180;
        return 'translate(' + x.toFixed(3) + ' ' + y.toFixed(3) + ') rotate(' + r.toFixed(1) + ' 50 50)';
    }
    var shapes = [];
    shapes.push('<rect x="0" y="0" width="100%" height="100%" fill="' + nextColor() + '" />');
    for (var i = 0; i < shapeCount; i++) {
        shapes.push('<rect x="0" y="0" width="100%" height="100%" transform="' + nextTransform(i) + '" fill="' + nextColor() + '" />');
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100">' + shapes.join('') + '</svg>';
}
exports.default = Jazzicon;
//# sourceMappingURL=index.js.map